import type { FunctionComponent } from 'react';
import React from 'react';
import classNames from 'classnames';

import { forNamespace } from '@trello/i18n';
import { BoardHeaderTestIds } from '@trello/test-ids';

import styles from './BoardTemplateBadge.less';

const format = forNamespace('board template badge');

type BadgeAppearances = 'default' | 'transparent';

interface BoardTemplateBadgeProps {
  dangerous_className?: string;
  /** The visible appearance of a template badge.
   *
   * @default 'default'
   */
  appearance?: BadgeAppearances;
}

export const BoardTemplateBadge: FunctionComponent<BoardTemplateBadgeProps> = ({
  dangerous_className,
  appearance = 'default',
}) => {
  return (
    <div
      className={classNames(
        styles.boardTemplateBadge,
        styles[appearance],
        dangerous_className,
      )}
      data-testid={BoardHeaderTestIds.TemplateBadge}
      title={format('templates are read-only boards for others to copy')}
    >
      {format('template')}
    </div>
  );
};
